export const randomAutoplaySpeedSlider = (Math.floor(Math.random() * 4) + 3) * 1000;